import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { CertificadoEmpresaA1Service } from '../../../../../shared/services/apis/dfe/certificado_empresa_a1.service';
import { GetSenhaCertificadoResponse } from '../../../../../shared/services/responses/dfe/get-senha-certificado.response';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-visualizar-senha-modal',
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButtonModule, MatProgressSpinnerModule,],
  templateUrl: './visualizar-senha-modal.component.html',
  styleUrl: './visualizar-senha-modal.component.css',
})
export class VisualizarSenhaModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<VisualizarSenhaModalComponent>,
    private certificadoService: CertificadoEmpresaA1Service,
    private alertService: AlertService
  ) { }

  isLoading = true;
  senha = '';

  ngOnInit(): void {
    this.buscarSenha();
  }

  buscarSenha(): void {
    if (!this.data.idCertificado) {
      this.alertService.show('Erro', 'ID do certificado não fornecido.', AlertType.error);
      this.dialogRef.close();
      return;
    }

    this.certificadoService.getSenhaCertificado(this.data.idCertificado).subscribe({
      next: (response: GetSenhaCertificadoResponse) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.dialogRef.close();
          return;
        }
        this.senha = response.senha;
      },
      error: (err) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', 'Não foi possível buscar a senha do certificado.', AlertType.error);
        this.dialogRef.close();
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
